// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2o58G","sendOtp":"AuthorizeToLogin_sendOtp__15edF"};